<div class="flex-col rounded-3xl bg-steel-100 px-7 py-7 md:flex md:px-10 md:py-12">
  <div class="grid grid-cols-1 gap-x-8 md:grid-cols-[220px_auto]">
    <rma-footer-contact class="order-last md:order-first xl:row-span-2" [details]="contactDetails$ | async" [socialLinks]="socialLinks" />
    <rma-footer-site-links class="mb-10" [linkGroups]="siteLinkGroups$ | async" />
    <rma-footer-quick-search
      class="md:col-span-2 xl:col-span-1"
      [links]="sitemapLinks$ | async"
      [hasFinance]="hasFinance$ | async"
      [hasLeasing]="hasLeasing$ | async"
    />
  </div>
</div>

<rma-legal-links [links]="legalLinks$ | async" />
